var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Icon',{staticClass:"entity__icon",attrs:{"icon":"folder","icon-pack":"fas","size":"lg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }